import React from 'react';

import Container from 'components/Misc/Container';
import { Input, Select } from 'components/Misc/Form';

import { useCourseStudentsStore } from 'store/course/useCourseStudentsStore';

const Search = () => {
	// Use grade student store
	const [search, onSearch] = useCourseStudentsStore(state => [state.search, state.onSearch]);

	return (
		<Container className="mt-4 p-4 flex gap-4">
			<Input
				type="text"
				name="name"
				placeholder="Vārds, Uzvārds"
				value={search.name}
				onChange={onSearch}
			/>

			{/* <Select
				name="state"
				placeholder="Ieskaites statuss"
				value={search.state}
				onChange={onSearch}
				options={[
					{ value: 'assigned', name: 'Pievienots' },
					{ value: 'active', name: 'Pašlaik pilda' }
				]}
			/> */}
		</Container>
	);
};

export default Search;